var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error404"},[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":"/imgs/404/404.png"},on:{"click":_vm.reback}})])}
var staticRenderFns = []

export { render, staticRenderFns }